import { useEffect, useState } from 'react';

const defaultDelay = 300;

// After looking at this for a while, i've decided this debouce hook is not very useful, causes to rerender every time the value changes
export const useDebounce = <T,>(value: T, delay = defaultDelay): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
};
